<template>
  <el-menu default-active="" class="menu" router>
    <img class="logo" src="@/assets/logo_rectangle_white.png" style="width:90%;margin:10px 5%;" />
    <el-menu-item index="/report">
      <i class="el-icon-s-data icon-white"></i>
      <span slot="title">Report</span>
    </el-menu-item>
    <el-menu-item index="/offer">
      <i class="el-icon-document-checked icon-white"></i>
      <span slot="title">Approved Offers</span>
    </el-menu-item>
    <el-menu-item index="/mmpOffer">
      <i class="el-icon-document-checked icon-white"></i>
      <span slot="title">MMP offer Access</span>
    </el-menu-item>
    <!-- <el-menu-item index="/offerPayment">
      <i class="el-icon-coin icon-white"></i>
      <span slot="title">Number Confirmation</span>
    </el-menu-item> -->
    <el-menu-item index="/billing">
      <i class="el-icon-coin icon-white"></i>
      <span slot="title">Invoice Upload</span>
    </el-menu-item>
    <el-menu-item index="/implog">
      <i class="el-icon-document icon-white"></i>
      <span slot="title">Impression</span>
    </el-menu-item>
    <el-menu-item index="/apiDocument">
      <i class="el-icon-data-line icon-white"></i>
      <span slot="title">Api Document</span>
    </el-menu-item>    

  </el-menu>
</template>
<script>
export default {
	data() {
		return {};
	},
};
</script>
<style scoped>
.menu,
.el-menu-item {
  background-color: rgba(255, 255, 255, 0);
  color: white;
  font-size: 14px;
  text-align: left;
  border: 0;
  font-weight: 500;
}
.el-menu-item.is-active {
  background-color: rgba(0, 0, 0, 0.4);
}
.logo {
  width: 50%;
  margin-left:50px;
}
.icon-white{
  color: white;
}
</style>
